export default {
  DISABLED: "0", // 無効
  ENABLED: "1" // 有効
}
